import { FiArrowRight } from "react-icons/fi";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import "./FroiCards.scss";
import { Link } from "react-router-dom";
import { cardVariants } from "../../styles/animationVars";
const cards = [
  {
    img: "/images/about/About_page_Model_Card_4.png",
    alt: "About_page_Model_Card",
    target: "/froi-model",
  },
  {
    img: "/images/about/About_page_Accreditation_Card_1.png",
    alt: "About_page_Accreditation_Card",
    target: "/froi-accreditation",
  },
  {
    img: "/images/about/About_page_TALENT SANDBOX_Card_2.png",
    alt: "About_page_TALENT SANDBOX_Card",
    target: "/froi-certification",
  },
  {
    img: "/images/about/About_page_Index_Card_3.png",
    alt: "About_page_Index_Card",
    target: "/froi-global-index",
  },
];

// const cardVariants = {
//   hidden: {
//     opacity: 0,
//     y: 60,
//   },

//   visible: (index) => ({
//     opacity: 1,
//     y: 0,
//     transition: {
//       duration: 0.8,
//       delay: index * 0.2,
//       ease: "easeInOut",
//     },
//   }),
// };
const FroiCards = () => {
  return (
    <section className="froi_section froi-initiatives">
      <Container className="froi-initiatives__container">
        <Row className="g-4">
          {cards.map((item, index) => (
            <Col key={index} xs={12} sm={6} lg={3}>
              <motion.div
                className="about-card"
                variants={cardVariants}
                custom={index}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.25 }}
              >
                <Link to={item.target}>
                  <img src={item.img} alt={item.alt} />
                </Link>
              </motion.div>
            </Col>
          ))}

          {/* {initiatives.map((item, index) => (
            <Col key={index} xs={12} sm={6} lg={3}>
              <motion.div
                className="initiative-card"
                variants={cardVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ amount: 0.25 }}
                transition={{
                  duration: 0.7,
                  delay: index * 0.15,
                  ease: "easeOut",
                }}
              >
                <h3 className="initiative-card__title">{item.title}</h3>

                <div className="initiative-card__content">
                  <p>{item.description}</p>

                  <div className="initiative-card__bottom">
                    <a href="#" className="initiative-card__link">
                      Explore more
                    </a>

                    <a
                      href="#"
                      className="initiative-card__arrow"
                      aria-label={`Explore ${index + 1}`}
                    >
                      <FiArrowRight />
                    </a>
                  </div>
                </div>
              </motion.div>
            </Col>
          ))} */}
        </Row>
      </Container>
    </section>
  );
};

export default FroiCards;
